import { render, staticRenderFns } from "./InvitationErrorsDialog.vue?vue&type=template&id=1cdbaa33&"
import script from "./InvitationErrorsDialog.vue?vue&type=script&lang=js&"
export * from "./InvitationErrorsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports